/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */
import type {
  FeatureFlagChangeListResponse,
  FeatureFlagListResponse,
  FeatureFlagResponse,
  ListFeatureFlagChangesParams,
  UpdateFeatureFlagBody,
} from "../model"

import { backofficeRequest } from "../../client"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Lists all feature flags
 */
export const listFeatureFlags = (
  options?: SecondParameter<typeof backofficeRequest<FeatureFlagListResponse>>,
) => {
  return backofficeRequest<FeatureFlagListResponse>(
    { url: `/featureFlags`, method: "GET" },
    options,
  )
}
/**
 * @summary Lists feature flag changes grouped by flag, newest first: one flag's history when featureId is set, otherwise changes across all flags
 */
export const listFeatureFlagChanges = (
  params?: ListFeatureFlagChangesParams,
  options?: SecondParameter<
    typeof backofficeRequest<FeatureFlagChangeListResponse>
  >,
) => {
  return backofficeRequest<FeatureFlagChangeListResponse>(
    { url: `/featureFlags/changes`, method: "GET", params },
    options,
  )
}
/**
 * @summary Updates a feature flag
 */
export const updateFeatureFlag = (
  id: number,
  updateFeatureFlagBody: UpdateFeatureFlagBody,
  options?: SecondParameter<typeof backofficeRequest<FeatureFlagResponse>>,
) => {
  return backofficeRequest<FeatureFlagResponse>(
    {
      url: `/featureFlags/${id}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateFeatureFlagBody,
    },
    options,
  )
}
export type ListFeatureFlagsResult = NonNullable<
  Awaited<ReturnType<typeof listFeatureFlags>>
>
export type ListFeatureFlagChangesResult = NonNullable<
  Awaited<ReturnType<typeof listFeatureFlagChanges>>
>
export type UpdateFeatureFlagResult = NonNullable<
  Awaited<ReturnType<typeof updateFeatureFlag>>
>
